import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { exportToCsv } from "@/lib/exportCsv";
import { toast } from "sonner";

export const ExportButton = ({ items, filename, testId = "export-csv-btn" }) => {
  const handleExport = () => {
    if (!items || items.length === 0) {
      toast.error("No records to export");
      return;
    }
    exportToCsv(filename, items);
    toast.success("Exported CSV");
  };
  return (
    <Button variant="outline" onClick={handleExport} data-testid={testId}>
      <Download className="h-4 w-4 mr-2" /> Export CSV
    </Button>
  );
};
